import { styled } from "@mui/material";

export default styled("div")`
    .list-header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 1em;
    }
`;
